module.exports = __webpack_public_path__ + "img/521.88cd9e2e.gif";